<template>
    <!-- 試算頁跟保障調整共用總計保費 --><!-- 底下保障迴圈還要再整理過 -->
    <div :id="'adjustItem' + (childKey + 1)">
        <div class="adjustmentFrame" :class="{ 'active': itemData.is_check }">
            <div class="adjustCaption" :class="'adjust_item_accu' + childKey" @click="adjustSelect($event)">
                <div class="name"><img :src="itemData.icon" alt="" class="adjustIcon">
                    <p> {{ itemData.user }}</p>
                </div>
                <div class="total">
                    <p>保費小計 : $<span>{{ formatMoney(rosterTotalPrem) }}</span></p>
                    <input type="checkbox" :checked="itemData.is_check" class="choose">
                </div>
            </div>
            <div class="assureAdjustCon">
                <ul class="topFixed">
                    <li class="adjustTitle">
                        <p>保障內容</p>
                        <p>保額</p>
                    </li>
                    <li class="line"></li>
                    <li>
                        <p>身故及失能或喪葬費用</p>
                        <div class="inputControl">
                            <input class="inputStyle" :value="formatMoney(travelAmount) + ' 萬'" readonly v-if="!itemData.is_check">
                            <select class="inputStyle arrow" v-if="itemData.is_check" v-model="travelAmount"
                                    @change="showHarmMedicalAmountList">
                                <option :value="item" v-for="(item,index) in travelAmountList" :key="index">{{ formatMoney(item) }} 萬</option>
                            </select>
                        </div>
                    </li>
                </ul>
                <div class="adjustDetail" v-if="itemData.is_check">
                    <ul>
                        <li>
                            <p>傷害醫療</p>
                            <div class="inputControl">
                                <select class="inputStyle arrow" v-if="itemData.is_check" v-model="harmMedicalAmount"
                                        @change="updateRoster">
                                    <option :value="item" v-for="(item,index) in harmMedicalAmountList" :key="index">{{ item }} 萬</option>
                                </select>
                            </div>
                        </li>
                        <li>
                            <p>個人賠償(每一事故自負額2,500元)</p>
                            <p>體傷20萬 / 財損10萬 / 保期內最高60萬</p>
                        </li>
                    </ul>
                    <ul v-if="mainPlan.oldIsCheck" :class="[{'active': mainPlan.isCheck}, 'adjust_' + mainPlan.planName + '_accu' + childKey]"
                        @click="planSelect($event,mainPlan, false)">
                        <li class="assureTitle">{{ mainPlan.plan_title }}</li>
                        <li v-for="(item, index) in mainPlan.plan_content" :key="index">
                            <p>{{ item.listItem }}</p>
                            <p>{{ item.listPrice }}</p>
                        </li>
                    </ul>
                   <div class="adjustProduct">
                        <ul v-for="(planObject, index) in plan" v-show="planObject.oldIsCheck" :key="index"
                            :class="[{'active': planObject.isCheck}, 'adjust_' + planObject.planName + '_accu' + childKey]"
                            @click="planSelect($event, planObject, false)">
                            <li class="assureTitle">{{ planObject.plan_title }}</li>
                            <li v-for="(item, key) in planObject.plan_content" :key="key">
                                <p>{{ item.listItem }}</p>
                                <p>{{ item.listPrice }}</p>
                            </li>
                        </ul>
                   </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
        import {onMounted, ref} from "vue";
        import $ from "jquery"

        const props = defineProps({
            childItem: Object,
            childKey: Number,
        })
        const emits = defineEmits(["updateRoster"]);

        let pageStorage = {};
        let travelAmountList = ref(null);
        let harmMedicalAmountList = ref(null);
        const itemData = ref(null);
        let mainPlan = ref(null);
        let plan = ref(null);
        const travelAmount = ref(0);
        const harmMedicalAmount = ref(0);
        const rosterTotalPrem = ref(0);
        let countDays = 0;
        //const carMotorPolicy = ref(false);
        const policyType = ref('')
        const adjustSelect=(event)=> {
            var vm = event.target;
            var adjustCon = $(vm).next().find('.adjustDetail');
            adjustCon.slideToggle();
            itemData.value.is_check = !itemData.value.is_check;
        }

        const planSelect=(event, item) =>{
            item.isCheck = !item.isCheck;
            updateRoster();
        }
        // 總保費加上千分位號","
        const formatMoney = (value) => {
            if (value === null || value === undefined) return null;
            return parseFloat(value).toLocaleString("zh-TW", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 50,
            });
        };
        const updateRoster = () => {
            pageStorage = JSON.parse(sessionStorage.getItem("pageStorage"));
            var roster = {
                'rosterNum': props.childKey,
                'rosterType': itemData.value.type,
                'planCode': mainPlan.value.planCode,
                'travelAmount': travelAmount.value * 10000,
                'harmMedicalAmount': harmMedicalAmount.value * 10000,
                'buyUneasyPolicy': mainPlan.value.isCheck,
                'buyCarPolicy': plan.value[0].isCheck,//汽車
                'buyMotorPolicy': plan.value[1].isCheck,//機車
                'buyTriathlon': plan.value[2].isCheck,//三鐵
                'buyTrafficAccident': plan.value[3].isCheck,//交通意外
                // 'buyBurnPolicy': plan.value[4].isCheck,//重大燒燙
            };
            pageStorage.rosters[props.childKey] = roster;
            sessionStorage.setItem("pageStorage", JSON.stringify(pageStorage));

            emits('updateRoster', props.childKey);
            calculatePlanPrice();
        }
        const loadAdjustData = () => {
            pageStorage = JSON.parse(sessionStorage.getItem("pageStorage"));
            countDays = pageStorage.countDays ? pageStorage.countDays : 0;
            itemData.value = props.childItem;
        }

        const loadRosterDetail = () => {
            //需要時間差載入，不然會跳出一坨錯誤
            mainPlan.value = pageStorage.mainPlan;
            mainPlan.value.oldIsCheck = mainPlan.value.isCheck;
            plan.value = pageStorage.plan;
            plan.value.forEach((planObject) => {
                planObject.oldIsCheck = planObject.isCheck;
            })
            //載入pageStorage
            travelAmount.value = pageStorage.rosters[props.childKey].travelAmount / 10000;
            harmMedicalAmount.value = pageStorage.rosters[props.childKey].harmMedicalAmount / 10000;
            mainPlan.value.planCode = pageStorage.mainPlan.planCode
            mainPlan.value.isCheck = pageStorage.rosters[props.childKey].buyUneasyPolicy;
            plan.value[0].isCheck = pageStorage.rosters[props.childKey].buyCarPolicy;
            plan.value[1].isCheck = pageStorage.rosters[props.childKey].buyMotorPolicy;
            plan.value[2].isCheck = pageStorage.rosters[props.childKey].buyTriathlon;
            plan.value[3].isCheck = pageStorage.rosters[props.childKey].buyTrafficAccident;//交通意外
            // plan.value[4].isCheck = pageStorage.rosters[props.childKey].buyBurnPolicy;//重大燒燙
            rosterTotalPrem.value = pageStorage.calculatePremRes.rosters[props.childKey].rosterTotalPremium;
            calculatePlanPrice();
        }

        const showTravelAmountList = () => {
            travelAmountList.value = pageStorage.amountList.travelAmountList;
            if (itemData.value.type === 2) {
                travelAmountList.value = [300]
            }
            if (itemData.value.type === 3 || itemData.value.type === 4) {
               travelAmountList.value = [69]
            }
        }
        const showHarmMedicalAmountList = () => {
            if (itemData.value.type === 1 || itemData.value.type === 5) {
                harmMedicalAmountList.value = pageStorage.amountList.harmMedicalAmountList[travelAmount.value];
            }
            //老人、小孩傷害醫療固定60000
            if (itemData.value.type === 2 || itemData.value.type === 3 || itemData.value.type === 4) {
                harmMedicalAmountList.value = [5]
            }
            var maxharmMedicalAmount = Math.max.apply(Math, harmMedicalAmountList.value);
            if (harmMedicalAmount.value > maxharmMedicalAmount) {
                harmMedicalAmount.value = maxharmMedicalAmount
            }

            updateRoster();
        }
        //計算最新被保人金額
        const calculatePlanPrice = () =>{
            //重大燒燙傷
            // const burnObject = plan.value.find(p => p.planName === "buyBurnPolicy");
            // if (policyType.value === "INSURE"){ //網要才能投保(網投INSURE狀況時隱藏)
            //     burnObject.hidePolicy = true;
            // }
            //汽機車投保、三鐵
            var CarObject = plan.value.find(p => p.planName === "buyCarPolicy");
            var MotorObject = plan.value.find(p => p.planName === "buyMotorPolicy");
            var TriathlonObject = plan.value.find(p => p.planName === "buyTriathlon");
            var TrafficObject = plan.value.find(p=> p.planName === "buyTrafficAccident");

            if(itemData.value.type === 3 ||itemData.value.type === 4){ //兒童幼童不可保
                TriathlonObject.oldIsCheck =false;
                TrafficObject.oldIsCheck = false;

                TriathlonObject.isCheck  =false;
                TrafficObject.isCheck = false;
            }
            if(itemData.value.type >= 3){
                CarObject.oldIsCheck = false
                MotorObject.oldIsCheck = false;

                CarObject.isCheck = false
                MotorObject.isCheck  = false;
            }

        }


        loadAdjustData();
        loadRosterDetail();
        defineExpose({ loadAdjustData,loadRosterDetail }) //父組件需使用

        onMounted(() => {
            //頁面初始載入、需較晚載入否則會有錯誤
            showTravelAmountList();
            showHarmMedicalAmountList();

        })




</script>

<style lang="scss">
.adjustmentFrame {
  margin: 30px auto;
  width: 100%;
  border-radius: 10px;
  &.active {
    background: #fff;

    .adjustCaption {
      background: $blue-700;
      box-sizing: border-box;
      .total {
        &::after {
          background-image: url(../../assets/yellowArrow.svg);
          background-repeat: no-repeat;
        }
      }
    }
    .assureAdjustCon{border:2px solid $blue-700;}
  }

  .adjustCaption {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #B6B6B7;
    box-sizing: border-box;
    padding: 10px;
    position: relative;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    @media screen and (max-width: $small) {
      font-size: 16px;
    }

    .name {
      img {
        display: inline-block;
        vertical-align: middle;
        width: 35px;
        max-height: 35px;
        @media screen and (max-width: $small) {
          width: 28px;
          max-height: 28px;
        }
      }

      p {
        display: inline-block;
        vertical-align: middle;
        margin: 0 10px;
        @media screen and (max-width: $small) {
          margin: 0 5px;
        }
      }

    }

    .total {
      p {
        margin-right: 40px;
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        right: 10px;
        top: 15px;
        width: 30px;
        height: 30px;
        background-image: url("../../assets/unadjust.svg");
        background-repeat: no-repeat;
        @media screen and (max-width: $small) {
          width: 25px;
          height: 25px;
          top: 10px;
          right: 10px;
          background-size: contain;
        }
      }
    }
  }

  .assureAdjustCon {
    border:2px solid #B6B6B7;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    ul {
      display: block;
      box-sizing: border-box;
      padding: 0 10px;

      &.topFixed {
        margin-bottom: 10px;
      }

      li {
        display: flex;
        justify-content: space-between;
        line-height: 40px;
        width: 100%;

        &.adjustTitle {
          p {
            font-weight: 500
          }
        }
        &.line{
          border:0;
          height:1px;
          background:$gray;
          margin:0 0 10px;
          &:after,&:before{
            width:5px;height:5px;margin-top:-2px;
          }
        }

        @media screen and (max-width: $small) {
          .inputControl {
            width: 50%;
            //.inputStyle.arrow{width:150px;}
          }
        }
      }
    }

    .adjustDetail {

      ul {
        &:nth-of-type(1){padding-bottom:10px;}
        &:nth-of-type(2){padding:10px;cursor:pointer;border-top:2px solid $blue-700;}
        li {
          &.mainPlanTitle{
            border-left: 2px solid $blue-700;
            color: $blue-700;
            padding-left: 10px;
            font-weight: bold;
            line-height: 25px;
            font-size: 18px;
            margin: 10px 0;
          }
          &.assureTitle {
            border-left: 2px solid $blue-700;
            color: $blue-700;
            padding-left: 10px;
            font-weight: bold;
            line-height: 25px;
            font-size: 18px;
            margin: 10px 0;

              &::after {
                  content:"加購";
                  background-color:$pink;
                  border-radius: 100px;
                  background-repeat: no-repeat;
                  color:#fff;
                  font-size: 16px;
                  font-weight: 400;
                  text-align: center;
                  display: inline-block;
                  vertical-align: middle;
                  padding:5px 20px;
                  box-sizing: border-box;
                  margin-right: 10px;
              }

          }

          @media screen and (max-width: $small) {
            font-size: 15px;
            margin: 10px 0;
            p {
              &:first-child {
                width: 50%;
                text-align: left;
                line-height: 20px;
              }

              &:last-child {
                width: 40%;
                line-height: 20px;
                text-align: right;
              }
            }

          }
        }

        &.active {
          background: $blue-400;
          &:last-of-type{border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;}
          li {
            &.assureTitle {
              &:after {
                content:"已加購"
              }
            }
          }
        }
      }
      .adjustProduct{
        ul{cursor: pointer;padding:10px;border-top:2px solid $blue-700;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
        }
      }

    }
  }

}</style>